(function () {
    'use strict';

    angular
        .module('app.accountSettings')
        .component('sc3AccountSettings', {
            templateUrl: 'app/account-settings/account-settings.component.html',
            bindings: { data: '<' }
        });
})();